module.exports = __webpack_public_path__ + "Bliss2-Bold.fd1d943e26f23aeb6b39.woff";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/Bliss2-Bold.woff
// module id = ../../../../../src/assets/layout/fonts/Bliss2-Bold.woff
// module chunks = styles